import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Box, Link, Typography } from '@mui/material';
import React from 'react';
import { useAlertUiTranslation } from '../../../../hooks';
import { humanFileSize } from '../../../alerts/form-widgets/WidgetLongMessage/Utils/TextTransformationUtil';
import { useInboxClient } from '../../hooks';
export const NotificationAttachmentListItem = ({ notificationId, attachment }) => {
    const attachmentSize = attachment.size ? humanFileSize(attachment.size) : '';
    const inboxClient = useInboxClient();
    const { t } = useAlertUiTranslation();
    const handleDownloadAttachment = (event) => {
        event.stopPropagation();
        inboxClient
            .createAttachmentSignature(notificationId, attachment.attachmentKey)
            .then((response) => window.location.assign(inboxClient.getDownloadAttachmentUrl(notificationId, attachment.attachmentKey, response.signature)))
            .catch(handleErrorSnackbar);
    };
    return (React.createElement(Box, { sx: { width: '100%', backgroundColor: themeColors.surface.tertiary, display: 'flex', alignItems: 'start' } },
        React.createElement(Link, { onClick: handleDownloadAttachment, underline: 'none', component: 'button', variant: 'body1', noWrap: true, sx: { display: 'flex', gap: 1, p: 1, cursor: 'pointer', alignItems: 'center' }, "aria-label": t('pages.tables.downloadAttachment', { name: attachment.name }) },
            React.createElement(FileDownloadOutlinedIcon, { color: 'primary' }),
            React.createElement(Typography, { color: themeColors.text.link, variant: 'subtitle2' },
                attachment.name,
                " (",
                attachmentSize,
                ")"))));
};
